var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 11.323V8.33464C15.8333 5.6538 14.0125 3.39547 11.5458 2.7163C11.3017 2.1013 10.705 1.66797 10 1.66797C9.295 1.66797 8.69833 2.1013 8.45417 2.7163C5.9875 3.3963 4.16667 5.6538 4.16667 8.33464V11.323L2.74417 12.7455C2.66663 12.8227 2.60514 12.9146 2.56324 13.0157C2.52133 13.1168 2.49984 13.2252 2.5 13.3346V15.0013C2.5 15.2223 2.5878 15.4343 2.74408 15.5906C2.90036 15.7468 3.11232 15.8346 3.33333 15.8346H16.6667C16.8877 15.8346 17.0996 15.7468 17.2559 15.5906C17.4122 15.4343 17.5 15.2223 17.5 15.0013V13.3346C17.5002 13.2252 17.4787 13.1168 17.4368 13.0157C17.3949 12.9146 17.3334 12.8227 17.2558 12.7455L15.8333 11.323ZM15.8333 14.168H4.16667V13.6796L5.58917 12.2571C5.6667 12.1799 5.72819 12.0881 5.7701 11.9869C5.812 11.8858 5.83349 11.7774 5.83333 11.668V8.33464C5.83333 6.03714 7.7025 4.16797 10 4.16797C12.2975 4.16797 14.1667 6.03714 14.1667 8.33464V11.668C14.1667 11.8896 14.2542 12.1013 14.4108 12.2571L15.8333 13.6796V14.168ZM10 18.3346C10.5161 18.3353 11.0195 18.1751 11.4404 17.8764C11.8613 17.5777 12.1786 17.1553 12.3483 16.668H7.65167C7.82139 17.1553 8.13873 17.5777 8.55959 17.8764C8.98045 18.1751 9.48392 18.3353 10 18.3346Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBell);
export default __webpack_public_path__ + "static/media/bx-bell.c997f75bd61a923705719f2cb68b37dc.svg";
export { ForwardRef as ReactComponent };